export default {
  dataAutomaticPublication: state => field => state[field],
  getTemplates: state => partnerId => {
    const partnerInfo = state.masterDataMasive.find(
      partner => partner.partnerId.toString() === partnerId
    );
    if (partnerInfo) return partnerInfo.campaignTemplatesInfo;
    return [];
  },
  getMilAgeMatrix: state => partnerId => {
    const partnerInfo = state.masterDataMasive.find(
      partner => partner.partnerId.toString() === partnerId
    );
    if (partnerInfo) return partnerInfo.mileageMatrix;
    return null;
  }
};
